var _polygon, _polygon2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFancyDownCarat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 315.9 240.8",
    enableBackground: "new 0 0 315.9 240.8",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "stroke2",
    fill: "#11753C",
    strokeWidth: 10,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "277.1,50.1  264.5,37.5 157.7,144.3 50.9,37.5 38.3,50.1 7,50.1 7,81.5 157.7,232.2 308.4,81.5 308.4,50.1 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "stroke1",
    fill: "#2C9947",
    strokeWidth: 10,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "157.7,113  50.9,6.2 7,50.1 157.7,200.8 308.4,50.1 264.5,6.2 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFancyDownCarat);
export default __webpack_public_path__ + "static/media/fancyDownCarat.882c9e68fc46bc4a8d68baed34049be8.svg";
export { ForwardRef as ReactComponent };